import appSlice from '../features/AppSlice';
import applicationSlice from '../features/ApplicationSlice';
import contactSlice from '../features/ContactSlice';
import dashboardSlice from '../features/DashboardSlice';
import decisionSlice from '../features/DecisionSlice';
import policySlice from '../features/PolicySlice';
import qiSlice from '../features/QISlice';
import quoteSlice from '../features/QuoteSlice';
import userSlice from '../features/UserSlice';
import underwritingSlice from '../features/UnderwritingSlice';

const reducers = {
  app: appSlice.reducer,
  application: applicationSlice.reducer,
  contact: contactSlice.reducer,
  dashboard: dashboardSlice.reducer,
  decision: decisionSlice.reducer,
  policy: policySlice.reducer,
  qi: qiSlice.reducer,
  quote: quoteSlice.reducer,
  user: userSlice.reducer,
  underwriting: underwritingSlice.reducer,
};

export default reducers;
